export default __webpack_public_path__ + "static/media/x-circle.d33e0229.svg";